import { toast } from "react-toastify";
import axios, { adminInstance } from "./Axios";

// Wrapper Functions
export function getWrapper(url, useAdminInstance = false) {
  return new Promise(async (resolve, reject) => {
    try {
      const instance = useAdminInstance ? adminInstance : axios;
      const res = await instance.get(url);
      return resolve(res.data);
    } catch (e) {
      if (e.response) {
        console.error(
          `[${useAdminInstance ? "Admin API" : "API"}] Response status: ${
            e.response.status
          }, data:`,
          e.response.data
        );
      }
      return reject(e);
    }
  });
}

export function postWrapper(url, data, header) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(url, data, header);
      return resolve(res.data);
    } catch (e) {
      if (e.response) {
        console.error(
          `[API] Response status: ${e.response.status}, data:`,
          e.response.data
        );
      }
      if (e.message && e.message.includes("Network Error")) {
        console.error(
          "[API] Network connection issue detected - might indicate session problems"
        );
      }

      if (url.includes("/api/loan/apply")) {
        // Check if JWT exists and is potentially valid
        const jwt = localStorage.getItem("jwtToken");
        if (jwt) {
          try {
            const tokenParts = jwt.split(".");
            if (tokenParts.length === 3) {
              const payload = JSON.parse(atob(tokenParts[1]));
              const expiry = payload.exp
                ? new Date(payload.exp * 1000)
                : "unknown";
              const now = new Date();
              console.error(
                `[API] JWT expiry: ${expiry}, current time: ${now}, expired: ${
                  expiry !== "unknown" && expiry < now
                }`
              );
            } else {
              console.error("[API] JWT token format invalid");
            }
          } catch (tokenErr) {
            console.error("[API] Failed to parse JWT token:", tokenErr);
          }
        }
      }

      return reject(e);
    }
  });
}

export function putWrapper(url, data) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.put(url, data);
      return resolve(res.data);
    } catch (e) {
      console.error(`[API] PUT error for ${url}:`, e.message);
      if (e.response) {
        console.error(
          `[API] Response status: ${e.response.status}, data:`,
          e.response.data
        );
      }
      return reject(e);
    }
  });
}

export function putFormDataWrapper(url, data) {
  return new Promise(async (resolve, reject) => {
    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 15000,
      };

      const startTime = Date.now();
      const res = await axios.put(url, data, config);
      return resolve(res.data);
    } catch (e) {
      console.error(`[API] PUT FormData error for ${url}:`, e.message);

      if (e.response) {
        console.error(
          `[API] Response status: ${e.response.status}, data:`,
          e.response.data
        );
      }

      if (e.message && e.message.includes("Network Error")) {
        console.error(
          "[API] Network connection issue detected - might indicate timeout or auth problems"
        );
      }

      return reject(e);
    }
  });
}

export function postBlobWrapper(url, data, acceptHeader = "*/*") {
  return new Promise(async (resolve, reject) => {
    try {
      const config = {
        headers: { Accept: acceptHeader },
        responseType: "blob",
      };
      const res = await axios.post(url, data, config);
      return resolve(res.data);
    } catch (e) {
      if (e.response) {
        console.error(
          `Response status: ${e.response.status}, data:`,
          e.response.data
        );
      }
      if (e.message && e.message.includes("Network Error")) {
        console.error(
          "Network connection issue detected - might indicate session problems"
        );
      }
      return reject(e);
    }
  });
}

export function postBlobFullResponse(url, data, extraConfig = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      const config = {
        ...extraConfig,
        headers: {
          Accept: "*/*",
          ...(extraConfig.headers || {}),
        },
        responseType: "blob",
      };
      const res = await axios.post(url, data, config);
      return resolve(res);
    } catch (e) {
      if (e.response) {
        toast.error(
          `Response status: ${e.response.status}, data:`,
          e.response.data
        );
      }
      if (e.message && e.message.includes("Network Error")) {
        toast.error(
          "Network connection issue detected - might indicate session problems"
        );
      }
      return reject(e);
    }
  });
}

export function getBlobWrapper(url, acceptHeader = "*/*") {
  return new Promise(async (resolve, reject) => {
    try {
      const config = {
        headers: { Accept: acceptHeader },
        responseType: "blob",
      };
      const res = await axios.get(url, config);
      return resolve(res.data);
    } catch (e) {
      if (e.response) {
        console.error(
          `Response status: ${e.response.status}, data:`,
          e.response.data
        );
      }
      if (e.message && e.message.includes("Network Error")) {
        console.error(
          "Network connection issue detected - might indicate session problems"
        );
      }
      return reject(e);
    }
  });
}

export function deleteWrapper(url, data) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.delete(url, { data });
      return resolve(res.data);
    } catch (e) {
      if (e.response) {
        console.error(`Error:`, e.response.data);
      }
      return reject(e);
    }
  });
}
